import React, { Children, cloneElement } from 'react';

const truncateText = (text, maxLength = 20) => {
  if (typeof text !== 'string' || !text) {
    return text;
  }
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength - 3)}...`;
  }
  return text;
};

const BreadCrumbs = ({ children, icon }) => {
  const arrayChildren = Children.toArray(children);

  return (
    <ul className="breadcrumbs flex">
      {icon ? <li className="icon">{icon}</li> : null}
      {Children.map(arrayChildren, (child, index) => {
        const childContent =
          typeof child === 'string' ? truncateText(child, 40) : child;
        const processedChild = React.isValidElement(child)
          ? cloneElement(child, {
              ...child.props,
              children: truncateText(child.props.children, 40),
              // title: typeof child.props.children === 'string' ? child.props.children : '',
            })
          : childContent;

        return (
          <li
            className={
              arrayChildren.length === 1 || index !== arrayChildren.length - 1
                ? 'text-muted'
                : ''
            }
          >
            {index > 0 ? <span className="divider text-muted">/</span> : null}
            {processedChild}
          </li>
        );
      })}
    </ul>
  );
};

export default BreadCrumbs;
